"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ej2ReactRichtexteditor = require("@syncfusion/ej2-react-richtexteditor");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@mui/material/styles");
var _ej2Base = require("@syncfusion/ej2-base");
var _styles2 = require("@mui/styles");
require("@syncfusion/ej2-base/styles/material.css");
require("@syncfusion/ej2-buttons/styles/material.css");
require("@syncfusion/ej2-calendars/styles/material.css");
require("@syncfusion/ej2-dropdowns/styles/material.css");
require("@syncfusion/ej2-inputs/styles/material.css");
require("@syncfusion/ej2-lists/styles/material.css");
require("@syncfusion/ej2-navigations/styles/material.css");
require("@syncfusion/ej2-popups/styles/material.css");
require("@syncfusion/ej2-splitbuttons/styles/material.css");
require("@syncfusion/ej2-react-richtexteditor/styles/material.css");
var _Portal = require("@mui/base/Portal");
var _Switch = _interopRequireDefault(require("@mui/material/Switch/Switch.js"));
var _uuid = require("uuid");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(0, _ej2Base.registerLicense)('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9ec3VXR2BZVkB1X0o=');
const useStyles = (0, _styles2.makeStyles)({
  customToolbar: {
    '& .e-toolbar-item .e-tbar-btn .e-btn-icon': {
      fontSize: '12px !important',
      width: '1em !important'
    },
    '& .e-toolbar-items': {
      width: '100%',
      overflowX: 'auto'
    }
  },
  readOnly: {
    height: '100%',
    '& .e-toolbar-wrapper': {
      display: 'none'
    },
    '& .e-rte-container': {
      borderWidth: '0px'
    }
  },
  darkModeEditor: {
    // Set Background color based on theme
    '& .e-richtexteditor .e-rte-content, \
         & .e-richtexteditor .e-source-content, \
         & .e-toolbar .e-toolbar-items, \
         & .e-toolbar, \
         & .e-toolbar.e-extended-toolbar .e-toolbar-pop, \
         & .e-toolbar .e-hor-nav, \
         & .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn, \
         & .e-toolbar .e-toolbar-item.e-overlay, \
         & .e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item.e-overlay': {
      background: '#24292E'
    },
    '& .e-toolbar .e-toolbar-item .e-tbar-btn:active': {
      background: '#616161',
      borderColor: '#616161'
    },
    '& .e-toolbar .e-tbar-btn, & .e-toolbar .e-toolbar-item .e-tbar-btn': {
      background: 'none',
      color: '#fff'
    },
    '& .e-toolbar .e-tbar-btn.e-btn .e-icons': {
      color: '#fff !important'
    },
    '& .e-toolbar .e-tbar-btn:hover': {
      background: 'rgba(255, 255, 255, .1)',
      borderColor: '#000',
      borderRadius: '2px',
      color: '#fff'
    }
  }
});
const SyncFusionRTE = ({
  value,
  onChange,
  placeholder,
  editable = true,
  minHeight = 250,
  imageHandlerConfig,
  isAutoSaveOn,
  onAutoSaveToggle,
  enableAutoSave
}) => {
  const theme = (0, _styles.useTheme)();
  const isDarkMode = theme.palette.mode === 'dark';
  const classes = useStyles({
    editable
  });
  const rtfRef = (0, _react.useRef)(null);
  const [switchContainer, setSwitchContainer] = (0, _react.useState)(null);
  const [isClient, setIsClient] = (0, _react.useState)(false);
  const uniqueId = (0, _react.useRef)((0, _uuid.v1)());
  (0, _react.useEffect)(() => {
    setIsClient(true);
  }, []);
  (0, _react.useEffect)(() => {
    const cssId = 'syncfusion-theme';
    const themeName = isDarkMode ? 'material-dark' : 'material';
    const applyTheme = () => {
      let linkElement = document.getElementById(cssId);
      if (linkElement) {
        linkElement.href = `https://tadacdn.tadanow.com/syncfusion/${themeName}.css`;
      } else {
        linkElement = document.createElement('link');
        linkElement.id = cssId;
        linkElement.rel = 'stylesheet';
        linkElement.href = `https://tadacdn.tadanow.com/syncfusion/${themeName}.css`;
        document.head.appendChild(linkElement);
      }
    };
    applyTheme();
    return () => {
      const linkElement = document.getElementById(cssId);
      if (linkElement) {
        linkElement.onload = null;
      }
    };
  }, [isDarkMode]);
  const handleRTEChange = e => {
    if (onChange) {
      onChange(e.value === null ? '' : e.value);
    }
  };
  const quickToolbarSettings = {
    text: ['Bold', 'Italic', 'Underline', 'StrikeThrough', 'FontSize', 'JustifyLeft', 'JustifyCenter', 'JustifyRight']
  };
  const toolbarSettings = editable ? {
    type: _ej2ReactRichtexteditor.ToolbarType.Expand,
    items: ['FullScreen', 'Bold', 'Italic', 'Underline', 'StrikeThrough', 'InlineCode', 'FontName', 'FontSize', 'FontColor', 'BackgroundColor', 'LowerCase', 'UpperCase', '|', ...(enableAutoSave ? [{
      template: `<div id="AutoSaveSwitch-${uniqueId.current}" style="display:inline-block;"></div>`,
      tooltipText: 'Enable Auto-Save'
    }] : []), 'Formats', 'Alignments', 'OrderedList', 'UnorderedList', 'Outdent', 'Indent', '|', 'CreateLink', 'Image', 'CreateTable', '|', 'Undo', 'Redo', 'SourceCode']
  } : {
    items: []
  };
  const handleKeyDown = event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event?.stopPropagation(); // Prevent the event from bubbling up to the slider
    }
  };
  const getFileFromBlobUrl = async (blobUrl, fileName = 'image.png') => {
    try {
      // Fetch the blob data from the URL
      const response = await fetch(blobUrl);

      // Convert the response into a blob
      const blob = await response.blob();

      // Create a File object from the blob
      const file = new File([blob], fileName, {
        type: blob.type
      });
      return file;
    } catch (error) {
      console.error('Error fetching the blob URL:', error);
      throw error;
    }
  };
  const handleImageUploading = async file => {
    const token = await imageHandlerConfig.getTokenForFile(file);
    const src = imageHandlerConfig.getSrcUrlFromToken(token);
    const editorInstance = rtfRef.current;
    editorInstance.executeCommand('insertImage', {
      src: src,
      width: '200px',
      dataToken: token
    });
  };
  const handleActionBegin = async args => {
    if ((args.requestType === 'Paste' || args.requestType === 'Images') && args.originalEvent) {
      let items = [];
      if (args.requestType === 'Paste') {
        items = args.originalEvent.clipboardData.items;
      } else {
        items = args.originalEvent.dataTransfer.items;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf('image') !== -1) {
          const file = item.getAsFile();
          if (file) {
            args.cancel = true;
            await handleImageUploading(file);
          }
        }
      }
    } else if (args.requestType === 'Image' && args.itemCollection && args.itemCollection.url) {
      args.cancel = true;
      const file = await getFileFromBlobUrl(args.itemCollection.url, args.itemCollection.altText);
      if (file && file.type.indexOf('image') !== -1) {
        await handleImageUploading(file);
      }
    }
  };
  const handleCreated = () => {
    const container = document.getElementById(`AutoSaveSwitch-${uniqueId.current}`);
    setSwitchContainer(container);
  };
  const handleActionComplete = args => {
    if (args.requestType === 'Paste') {
      setTimeout(() => {
        if (rtfRef.current) {
          const rteInstance = rtfRef.current;

          // Get the latest pasted HTML content
          const latestHtml = rteInstance.getHtml();

          // Modify background and text colors in pasted HTML
          const cleanedHtml = (0, _utils.adjustContentStyles)(latestHtml);

          // Replace editor content with the modified version
          rteInstance.value = cleanedHtml;
        }
      }, 50);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isClient ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: (0, _classnames.default)({
        [classes.darkModeEditor]: isDarkMode,
        [classes.readOnly]: !editable
      }),
      onKeyDown: handleKeyDown,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ej2ReactRichtexteditor.RichTextEditorComponent, {
        ref: rtfRef,
        cssClass: classes.customToolbar,
        height: minHeight,
        readonly: !editable,
        value: value,
        change: handleRTEChange,
        toolbarSettings: toolbarSettings,
        placeholder: placeholder,
        quickToolbarSettings: quickToolbarSettings,
        actionBegin: handleActionBegin
        //actionComplete={handleActionComplete}
        ,
        created: handleCreated,
        ...(isAutoSaveOn && {
          saveInterval: 2000
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ej2ReactRichtexteditor.Inject, {
          services: [_ej2ReactRichtexteditor.Toolbar, _ej2ReactRichtexteditor.HtmlEditor, _ej2ReactRichtexteditor.Image, _ej2ReactRichtexteditor.Link, _ej2ReactRichtexteditor.QuickToolbar, _ej2ReactRichtexteditor.PasteCleanup, _ej2ReactRichtexteditor.Table]
        })
      }), switchContainer && enableAutoSave && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
        container: switchContainer,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch.default, {
          className: "custom-switch",
          checked: isAutoSaveOn,
          onChange: (event, checked) => onAutoSaveToggle && onAutoSaveToggle(checked),
          color: "primary",
          sx: {
            '& .MuiSwitch-input': {
              height: '100% !important'
            }
          }
        })
      })]
    }) : null
  });
};
var _default = exports.default = SyncFusionRTE;